import { render, staticRenderFns } from "./ContractDetail.vue?vue&type=template&id=f4af05ca&scoped=true&"
import script from "./ContractDetail.vue?vue&type=script&lang=js&"
export * from "./ContractDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4af05ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4af05ca')) {
      api.createRecord('f4af05ca', component.options)
    } else {
      api.reload('f4af05ca', component.options)
    }
    module.hot.accept("./ContractDetail.vue?vue&type=template&id=f4af05ca&scoped=true&", function () {
      api.rerender('f4af05ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/job-request/components/ContractDetail.vue"
export default component.exports